(function () {
  var wrappers = document.querySelectorAll('.ryp-video__wrapper');
  if (!wrappers.length) return;

  wrappers.forEach(function (wrapper) {
    var playBtn = wrapper.querySelector('.ryp-video__play');
    var videoEl = wrapper.querySelector('.ryp-video__player');
    if (!playBtn || !videoEl) return;

    var img = wrapper.querySelector('.ryp-video__img');

    playBtn.addEventListener('click', function () {
      if (img) img.style.display = 'none';
      playBtn.style.display = 'none';
      videoEl.style.display = 'block';
      videoEl.play();
    });
  });
})();
